// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps {
  text-align: left;
  margin-left: auto;
  width: 61%;
  margin-bottom: 16px;
}
.steps .step .step-text {
  margin-left: 12px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  color: var(--color-card-text);
}
.steps .step .fa-circle {
  font-size: 14px;
  color: var(--color-primary);
  margin-bottom: 20px;
}

.app-flow {
  font-size: 18px;
  background-color: var(--color-card-background);
}
.app-flow .step-content .brand-desc {
  font-weight: 600;
  font-size: 30px;
  line-height: 120%;
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
  margin: 0;
  color: var(--color-card-text);
}
.app-flow .step-content .policy-info {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 150%;
  color: var(--color-primary);
}
.app-flow .step-content .app-instruction {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 120%;
  color: var(--color-card-text);
  order: 2;
  margin: 24px 0px;
}

.next-btn:focus-within {
  outline: black solid 2px;
  outline-offset: 0px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/start/start.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AACF;AACI;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AACN;AACI;EACE,eAAA;EACA,2BAAA;EACA,mBAAA;AACN;;AAIA;EACE,eAAA;EACA,8CAAA;AADF;AAGI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;AADN;AAGI;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AADN;AAGI;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,QAAA;EACA,gBAAA;AADN;;AAKA;EACE,wBAAA;EACA,mBAAA;AAFF","sourcesContent":[".steps {\n  text-align: left;\n  margin-left: auto;\n  width: 61%;\n  margin-bottom: 16px;\n  .step {\n    .step-text {\n      margin-left: 12px;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 120%;\n      color: var(--color-card-text);\n    }\n    .fa-circle {\n      font-size: 14px;\n      color: var(--color-primary);\n      margin-bottom: 20px;\n    }\n  }\n}\n\n.app-flow {\n  font-size: 18px;\n  background-color: var(--color-card-background);\n  .step-content {\n    .brand-desc {\n      font-weight: 600;\n      font-size: 30px;\n      line-height: 120%;\n      display: flex;\n      flex-direction: column;\n      padding: 16px 0px;\n      margin: 0;\n      color: var(--color-card-text);\n    }\n    .policy-info {\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 150%;\n      color: var(--color-primary);\n    }\n    .app-instruction {\n      font-style: normal;\n      font-weight: normal;\n      font-size: 16px;\n      line-height: 120%;\n      color: var(--color-card-text);\n      order: 2;\n      margin: 24px 0px;\n    }\n  }\n}\n.next-btn:focus-within {\n  outline: black solid 2px;\n  outline-offset: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
